module.exports = __webpack_public_path__ + "img/NC-Logo_white.d822f28b.png";